import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Context } from '@front10/helpers/dist/Context';
import useStyles from '@front10/helpers/dist/UseStyles';
import Box from '../../elements/Box';
import Row from '../../elements/Row';
import Col from '../../elements/Col';
import Button from '../../elements/Button';
import Link from '../../elements/Link';

const NoFeaturedPopularFaresAlert = (props) => {
  const { direction, translate, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  const {
    row,
    linkStyles,
    buttonClearStyles,
    labelKeyTitle,
    labelKeyLink,
    labelKeyClearFilters,
    showLink,
    showClearFilters,
    onLinkClick,
    dispatch,
    boxContainer = { marginBottom: '2' },
    col = { textAlign: 'center' },
    showNoResultLink,
    noResultLink,
    noResultLinkSettings,
    prePopulation,
    focusFirstElement,
    enableAccessibilityMessage = false,
    messageAriaHidden = false
  } = props;

  const { siteEdition } = prePopulation;
  const { urls, defaultUrl } = noResultLink;
  let noResultLinkTmp = defaultUrl ?? '';

  if (urls && urls[siteEdition]) {
    noResultLinkTmp = urls[siteEdition];
  }

  return (
    <Row {...row}>
      <Col {...col}>
        <Box
          className={className}
          style={style}
          dataTestId="noFeaturedPopularFaresAlert"
          role={enableAccessibilityMessage ? null : 'alert'}
        >
          {!showNoResultLink ? (
            <Box {...boxContainer}>
              <span
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: translate(
                    labelKeyTitle,
                    'No fares were found for the selected criteria. Please try again with different City, Date Range and Budget.'
                  )
                }}
                aria-hidden={messageAriaHidden ? true : false}
              />
            </Box>
          ) : (
            <Link href={noResultLinkTmp} {...noResultLinkSettings}>
              {translate(
                labelKeyTitle,
                'No fares were found for the selected criteria. Please try again with different City, Date Range and Budget.'
              )}
            </Link>
          )}
          {showLink && (
            <Box
              tabIndex={0}
              onClick={onLinkClick}
              onKeyDown={($event) => {
                if ($event.keyCode === 13) {
                  onLinkClick();
                }
              }}
              className="fr-cmp-location-selector-error-mobile-reload"
              dataTestId="containerErrorAlert"
              {...linkStyles}
            >
              {translate(labelKeyLink, 'More homes options')}
            </Box>
          )}
          {showClearFilters && (
            <Button
              onClick={() => {
                dispatch({ type: 'CLEAR_ALL' });
                focusFirstElement && focusFirstElement();
              }}
              dataTestId="clearFilters"
              color="primary"
              {...buttonClearStyles}
            >
              {translate(labelKeyClearFilters, 'Clear filters')}
            </Button>
          )}
        </Box>
      </Col>
    </Row>
  );
};

NoFeaturedPopularFaresAlert.propTypes = {
  row: PropTypes.objectOf(PropTypes.any),
  linkStyles: PropTypes.objectOf(PropTypes.any),
  buttonClearStyles: PropTypes.objectOf(PropTypes.any),
  labelKeyTitle: PropTypes.string,
  labelKeyLink: PropTypes.string,
  labelKeyClearFilters: PropTypes.string,
  showLink: PropTypes.bool,
  showClearFilters: PropTypes.bool,
  onLinkClick: PropTypes.func,
  dispatch: PropTypes.func,
  showNoResultLink: PropTypes.bool,
  noResultLink: PropTypes.objectOf(PropTypes.any),
  noResultLinkSettings: PropTypes.objectOf(PropTypes.any),
  prePopulation: PropTypes.objectOf(PropTypes.any)
};

NoFeaturedPopularFaresAlert.defaultProps = {
  row: {},
  linkStyles: {
    textColor: 'info',
    textDecoration: 'underline',
    textTransform: 'capitalize',
    fontWeight: 'bold'
  },
  buttonClearStyles: {},
  onLinkClick: () => {},
  dispatch: () => {},
  labelKeyTitle: 'cmp-no-featured-popular-fares-alert-info',
  labelKeyLink: 'cmp-text-tryagain',
  labelKeyClearFilters: 'cmp-clear-filters',
  showLink: false,
  showClearFilters: false,
  showNoResultLink: false,
  noResultLink: {},
  noResultLinkSettings: {},
  prePopulation: {},
  paddingHeight: '4'
};

NoFeaturedPopularFaresAlert.componentName = 'NoFeaturedPopularFaresAlert';
export default NoFeaturedPopularFaresAlert;
